/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {NgModule} from "@angular/core";

import {FlexLayoutModule} from "@angular/flex-layout";

import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {MatMenuModule} from "@angular/material/menu";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";

import {PostureChartModule} from "./posture-chart/posture-chart.module";
import {ListModule} from "./list/list.module";
import {PolarModule} from "./polar/polar.module";
import {VideoTableModule} from "./video-table/video-table.module";
import {VideoModule} from "./video-table/video/video.module";
import {PatterTableModule} from "./patter-table/patter-table.module";
import {TrajectoryModule} from "./trajectory/trajectory.module";
import {ScoreTableModule} from "./score-table/score-table.module";
import {BallisticChartModule} from "./ballistic-chart/ballistic-chart.module";
import {BallisticTabModule} from "./ballistic-tab/ballistic-tab.module";
import {BarChartModule} from "./bar-chart/bar-chart.module";

import {ShotComponent} from "./shot.component";
import {LayoutDialogComponent} from "./layout-dialog/layout-dialog.component";
import {LineChartModule} from "./line-chart/line-chart.module";
import {PatterTabModule} from "./patter-tab/patter-tab.module";
import {JudgmentModule} from "./judgment/judgment.module";
import {PostureTabModule} from "./posture-tab/posture-tab.module";
import {ImagesModule} from "./images/images.module";
import {CommonModule} from "@angular/common";
import {MessageDialogModule} from "../base/components/message-dialog/message-dialog.module";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
	declarations: [
		ShotComponent,
		LayoutDialogComponent,
	],
	imports: [
		CommonModule,
		FormsModule,

		FlexLayoutModule,

		MatDialogModule,

		MatCardModule,
		MatIconModule,
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatFormFieldModule,
		MatTooltipModule,

		PostureChartModule,
		ListModule,
		VideoModule,
		PostureTabModule,
		VideoTableModule,
		PolarModule,
		PatterTableModule,
		TrajectoryModule,
		ScoreTableModule,
		BallisticChartModule,
		BallisticTabModule,
		BarChartModule,
		LineChartModule,
		PatterTabModule,
		JudgmentModule,
		ImagesModule,

		MessageDialogModule,
		TranslateModule

	],
	exports: [ShotComponent],
	providers: [],
	bootstrap: [LayoutDialogComponent],
})

export class ShotModule {
}
